import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Transition from 'semantic-ui-react/dist/es/modules/Transition';
import 'semantic-ui-css/components/transition.min.css';

import './Welcome.css';
import { WelcomeSplash, Button, BaseImage } from 'web-store-modules/packages/web-store-ui-library/';
import { getWelcomeExploreUrlAsync } from '../../../utils/StaticAssetManager.js';
import { getWelcomeMessageStyleAsync, getWelcomeTitleAsync, getStyleColorAsync, getStoreId, polandMKId, lithuaniaMkId } from '../../../utils/StoreConfigManager.js';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import WelcomeTooltip from './WelcomeTooltip/WelcomeTooltip';
import { WelcomeMessageButtonClicked } from '../../../utils/Analytics';
import { storeTrans } from '../../../utils/StoreTranslator';

const defaultFontFamily = 'sans-serif';

const isMobile = isMobileDevice();
const storeId = getStoreId();
const welcomeShowTime = 18000;
const suite13Img = 'https://cdn.obsess-vr.com/mary-kay/MK_S13_MAIN_RGB.png';
const MKWhiteLogo = 'https://cdn.obsess-vr.com/mary-kay/MaryKay-logo-white-new.png';
const fontStyleByStoreArr = [polandMKId, lithuaniaMkId];
class Welcome extends Component {
    constructor(props) {
        super(props);
        this.hide = this.hide.bind(this);
        this.onHide = this.onHide.bind(this);

        this.state = {
            text: '',
            imageSrc: '',
            welcomeFadeout: '',
            visible: true,
            welcomeMessageStyle: null,
            pendingLoadAssetCount: 3,
            primaryColor: '',
            secondaryColor: '',
            showFlatImg: true,
            visibleTooltip: false,
            showWelTooltip: true,
            showBroseTooltip: false,
            showProductTooltip: false,
            showBeautyTooltip: false,
            isEnterBtn: true,
            showOverlay: true,
            showMobileTooltip: false
        };

        this.timeOutFunc = null;
        this.timeOutBrowseFunc = null;
        this.timeOutProductFunc = null;
        this.timeOutBeautyFunc = null;
    }

    componentDidMount() {
        getWelcomeMessageStyleAsync()
            .then(style => {
                if (style) {
                    const welcomeMessageStyle = {
                        fontFamily: style.name + ',' + defaultFontFamily
                    };
                    if (!isMobile) {
                        welcomeMessageStyle.fontSize = style.size;
                    }
                    this.setState(state => {
                        return {
                            welcomeMessageStyle: welcomeMessageStyle,
                            pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                        };
                    });
                }
            })
            .catch(error => console.error(error));

        getStyleColorAsync()
            .then(style => {
                const primaryColor = style[0];
                const secondaryColor = style[1];
                this.setState({ primaryColor, secondaryColor })
            })
            .catch(error => console.error(error));

        getWelcomeTitleAsync()
            .then(welcomeText => {
                this.setState(state => {
                    return {
                        text: welcomeText,
                        pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                    };
                });
            })
            .catch(error => console.error(error));

        getWelcomeExploreUrlAsync()
            .then(url => {
                const welcomeImage = new Image();
                welcomeImage.onload = () => {
                    this.setState(state => {
                        return {
                            pendingLoadAssetCount: state.pendingLoadAssetCount - 1
                        };
                    });
                }
                welcomeImage.src = url;
                this.setState({ imageSrc: url })
            })
            .catch(error => console.error(error));


        const { showingUI, showWelcomeTooltips, showingLoadingIcon } = this.props;
        if (showingUI && showWelcomeTooltips && !showingLoadingIcon) {
            this.onShowTooltip();
        }
    }

    componentWillUnmount() {
        if (isMobile) {
            window.removeEventListener('touchend', this.hideWelcomeTooltips);
        } else {
            window.removeEventListener('click', this.hideWelcomeTooltips);
        }
        clearTimeout(this.timeOutProductFunc);
        clearTimeout(this.timeOutBeautyFunc);
        clearTimeout(this.timeOutBrowseFunc);
        if (this.timeOutFunc) {
            clearTimeout(this.timeOutFunc);
        }
    }

    hide(type = '') {
        this.setState({ visible: false });
        this.onHide(type);
    }

    onHide(type = '') {
        this.setState({ welcomeFadeout: 'welcome-fadeout' });

        if (!this.state.showWelcomeTooltips) {
            WelcomeMessageButtonClicked();
        }

        setTimeout(() => {
            this.props.onWelcomeHide(type);
        }, 500);
    }

    onShowTooltip = () => {
        const { showingUI, showWelcomeTooltips, showingLoadingIcon } = this.props;
        if (this.state.showWelTooltip) {
            if (showingUI && showWelcomeTooltips && !showingLoadingIcon && !this.timeOutFunc) {
                this.timeOutFunc = setTimeout(() => {
                    this.hide();
                }, welcomeShowTime);

                if (isMobile) {
                    setTimeout(() => {
                        window.addEventListener('touchend', this.hide);
                    }, 500);
                } else {
                    setTimeout(() => {
                        window.addEventListener('click', this.hide);
                    }, 500);
                }
            }
            this.timeOutBrowseFunc = setTimeout(
                () => this.setState({ showWelTooltip: false, showBroseTooltip: true, visibleTooltip: true, welcomeFadeout: 'tooltip-show' }),
                100
            );

            this.timeOutProductFunc = setTimeout(() =>
                this.setState({ showProductTooltip: true }), 1100);
            this.timeOutBeautyFunc = setTimeout(() =>
                this.setState({ showBeautyTooltip: true }), 2100);
            if (isMobile) {
                this.timeOutPortraitFunc = setTimeout(() =>
                    this.setState({ showMobileTooltip: true }), 3100);
            }
        }
    }


    getUpdatedWelcomeMessageStyle() {
        const { isFlatImageScene } = this.props;
        const { welcomeMessageStyle } = this.state;
        const updatedWelcomeMessageStyle = { ...welcomeMessageStyle, fontSize: 36 };

        return isFlatImageScene ? updatedWelcomeMessageStyle : welcomeMessageStyle;
    }

    welcomeHtml = () => {
        return <div className="welcome-message" style={{fontFamily: fontStyleByStoreArr.includes(storeId) ? "MaryKaySansMedium" : null}} >
            <div className="welcome-heading">{storeTrans[storeId]['heading']}</div>
            <BaseImage id="welcome-img" src={suite13Img} />
            <div className="welcome-title">
                <span>{storeTrans[storeId]['title']}</span>
                <div>
                    <span>{storeTrans[storeId]['textBeforeBtn']}</span><BaseImage id="welcome-mk-img" src={MKWhiteLogo} />
                </div>
            </div>
        </div>
    }

    render() {
        const { showingUI, flatImageButtonOption, flatImageButtonText, firstImgLoaded, showWelcomeTooltips, isFirstTooltip } = this.props;
        const { text, visible, primaryColor, secondaryColor, welcomeFadeout, showBroseTooltip, showProductTooltip, showBeautyTooltip, visibleTooltip, isEnterBtn, showOverlay, showMobileTooltip } = this.state;

        if (!showingUI && !firstImgLoaded) {
            return <React.Fragment />;
        }

        const enterButton = <div className='top-layer-entry-button'>
            <Button primaryColor='#FFFFFF' secondaryColor="#FFFFFF" className='entry-button' onClick={() => this.hide('welcome-msg')}>
                <p style={{fontFamily: storeId===polandMKId ? "MaryKaySansMedium" : storeId===lithuaniaMkId ? "MaryKaySansMedium" : null}} className='entry-text'>{storeTrans[storeId]['entryText']}</p>
            </Button>
        </div>;

        const welcomeMsg = this.welcomeHtml();

        return (
            <div id={showOverlay ? 'welcome-overlay' : ''} className={welcomeFadeout}>
                {showingUI && !showWelcomeTooltips &&
                    <Transition
                        visible={visible}
                        animation='fade'
                        duration={300}
                        onClick={this.onHide}
                    >
                        <WelcomeSplash
                            welcomeMessageStyle={this.getUpdatedWelcomeMessageStyle()}
                            welcomeText={text}
                            hideTooltip={true}
                            hideWelcomeMessage={true}
                        >
                            {
                                flatImageButtonOption &&
                                <Button
                                    style={{ ...this.getUpdatedWelcomeMessageStyle(), padding: '0.2em 1em', marginTop: '0.5em' }}
                                    primaryColor={primaryColor}
                                    secondaryColor={secondaryColor}
                                >
                                    <p id='flat-image-button-text'>{flatImageButtonText}</p>
                                </Button>
                            }
                            {welcomeMsg}
                            {isEnterBtn && enterButton}
                        </WelcomeSplash>

                    </Transition>
                }

                {isFirstTooltip && showWelcomeTooltips &&
                    <Transition
                        visible={visibleTooltip}
                        animation='fade'
                        duration={500}
                    >
                        <WelcomeTooltip
                            welcomeMessageStyle={this.getUpdatedWelcomeMessageStyle()}
                            showBroseTooltip={showBroseTooltip}
                            showBeautyTooltip={showBeautyTooltip}
                            showProductTooltip={showProductTooltip}
                            showMobileTooltip={showMobileTooltip}
                            isVisible={visibleTooltip}
                            storeId={storeId}
                            isMobile={isMobile} 
                        >
                        </WelcomeTooltip>
                    </Transition>
                }
            </div>
        );
    }
}

Welcome.propTypes = {
    showingUI: PropTypes.bool,
    showWelcomeTooltips: PropTypes.bool,
    onWelcomeHide: PropTypes.func,
    isFlatImageScene: PropTypes.bool,
    flatImageButtonOption: PropTypes.bool,
    flatImageButtonText: PropTypes.string,
};

export default Welcome;
